import styled from "styled-components";

export const Proyectos = styled.p`
  width: 100px;
  transform: rotate(-90deg);
  font-size: 18px;
  color: white;
  @media (max-width: 460px) {
    display: none;
  }
`;
